export default __webpack_public_path__ + "static/media/browse.e8ddf1d0.svg";